import { createApi } from '@reduxjs/toolkit/query/react';
import { ogBaseQuery } from '../../ogBaseQuery';

export const storagesOGService = createApi({
  baseQuery: ogBaseQuery(),
  reducerPath: 'storagesOG',
  endpoints: (builder) => ({
    upload: builder.mutation<
      string,
      { storage: string; formData: FormData; imageType: string }
    >({
      query: (data) => ({
        url: `/Storages/${data.storage}/upload`,
        method: 'POST',
        params: {
          imageType: data.imageType,
        },
        body: data.formData,
      }),
      transformResponse: (data: { file: { url: string } }) => data.file.url,
    }),
  }),
});

export const {
  endpoints: { upload },
  useUploadMutation,
} = storagesOGService;
